@if (layoutManager) {
    @if (layoutManager.isEditing$ | async) {
        @if (saveError) {
            <div role="alert"
                 class="alert alert-danger">
                {{ saveError }}
            </div>
        }
        <div class="header">
            <div>
                <button adaptButtonIcon="refresh"
                        [adaptBlockingClick]="layoutManager.resetToDefaultLayout"
                        [disabled]="layoutManager.isLayoutDefault"
                        data-test="layout-reset-default-button">Reset to default layout</button>
            </div>
            <div class="d-flex align-items-center">
                @if (componentMenu && layoutManager.useHiddenComponentMenu) {
                    <adapt-menu class="mt-n1 mb-n1 me-1 d-inline-block"
                                data-test="layout-components-button"
                                [items]="componentMenu"
                                [showOnHover]="true"></adapt-menu>
                }

                @if (pageColumnMenu) {
                    <adapt-menu class="mt-n1 mb-n1 me-1 d-inline-block"
                                data-test="layout-options-button"
                                [items]="pageColumnMenu"
                                [showOnHover]="true"></adapt-menu>
                }

                <button adaptButtonIcon="save"
                        [adaptBlockingClick]="saveLayout"
                        [disabled]="layoutManager.isLayoutUnchanged"
                        data-test="layout-save-button">Save changes</button>
                <button adaptButtonIcon="cancel"
                        [adaptBlockingClick]="layoutManager.toggleEditing"
                        data-test="layout-cancel-button">Cancel changes</button>
            </div>
        </div>
    }
}
